<template>
  <form-wrap
    class="password-reset-form"
    @submit="handleCreate"
  >
    <form-field-set :should-show-border="false">
      <text-input
        v-model="workspace"
        :error="fieldError('create', 'workspace')"
        :label="$t('c.passwordResetForm.form.label.workspace')"
        name="workspace"
        direction="vertical"
      />
      <text-input
        v-model="email"
        :error="fieldError('create', 'email')"
        :label="$t('c.passwordResetForm.form.label.email')"
        name="email"
        direction="vertical"
      />
    </form-field-set>
    <form-actions>
      <button-input
        v-t="'c.passwordResetForm.form.action.submit'"
        type="submit"
      />
      <router-link
        v-t="'c.passwordResetForm.form.action.signin'"
        :to="{ name: 'SignInPage' }"
      />
    </form-actions>
  </form-wrap>
</template>

<script>
import {
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_ERROR
} from 'store/modules/notifications/types'
import FormMixin from '@/mixins/forms/Form'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PasswordResetForm',
  mixins: [FormMixin],
  computed: {
    ...mapGetters({
      fieldError: 'passwordResetForm/fieldError'
    }),
    email: {
      get () { return this.$store.state.passwordResetForm.form.email },
      set (value) { this.$store.dispatch('passwordResetForm/setEmail', value) }
    },
    workspace: {
      get () { return this.$store.state.passwordResetForm.form.workspace },
      set (value) { this.$store.dispatch('passwordResetForm/setWorkspace', value) }
    }
  },
  methods: {
    ...mapActions({
      create: 'passwordResetForm/create'
    }),
    ...mapActions([
      'addNotification'
    ]),
    handleCreate () {
      this.create()
        .then(() => {
          this.addNotification({
            message: 'Sie werden in Kürze eine E-Mail von uns erhalten.',
            type: NOTIFICATION_TYPE_SUCCESS
          })
          this.$router.push({ name: 'SignInPage' })
        })
        .catch(() => {
          this.addNotification({
            message: 'Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns.',
            type: NOTIFICATION_TYPE_ERROR
          })
        })
    }
  }
}
</script>

<style lang="sass">
.sign-in-form__password-reset-link
  font-size: 14px
  position: absolute
  right: 0
  top: -24px
</style>



// WEBPACK FOOTER //
// src/components/auth/PasswordResetForm.vue